import { Panel } from '@ixicare/ui';
import siteWrapper, { SiteWrapperProps } from '../utils/siteWrapper';
import SitePlaneFormContainer from '../containers/SitePlaneForm';
import { t } from '~i18n';

type SitePlaneCreatePageProps = SiteWrapperProps;

const SitePlaneCreatePage: React.FC<SitePlaneCreatePageProps> = ({ site }) => (
  <Panel>
    <Panel.Title>
      {site.name} {t('site.planes')}
    </Panel.Title>

    <SitePlaneFormContainer site={site} />
  </Panel>
);

export default siteWrapper(SitePlaneCreatePage);
